<div
  #pdfViewerContainer
  class="pdf-viewer-container"
>
  <div
    #pdfViewerRef
    class="pdf-viewer"
    id="viewer"
  ></div>

  <iframe
    #printAreaRef
    class="print-area"
    hidden
    id="printArea"
  ></iframe>
</div>
